module.exports = __webpack_public_path__ + "static/media/Inter-Bold.741dc416.woff2";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fonts/Inter/Inter-Bold.woff2
// module id = 680
// module chunks = 21